// ====================================
// * TEMPLATE TOOLBOX COMPONENT
// ====================================
//
// * This component template contains everything needed to create a new toolbox component
// * Consult toolbox/index.js for data on which filter properties will be dynamically loaded and the events they emit
// * To see configurable properties for dynamically loaded filter options, see components/ControlBase.vue
// 
// ====================================

<template>
  <control-base :config="conf" :dataType="dataType" :parentName="$options.name" @loaded="$emit('loaded', $event)" ref="base">
    <template v-slot:filters>
      <!-- Any custom data filters go here -->
    </template>
    <template v-slot:control>
      <!-- Actual control data goes here -->
    </template>
  </control-base>
</template>

<script>
export default {
  name: "TemplateComponent", // Component name must be exactly the same as the name you give it in the toolbox minus the spaces

  props: {
    config: {
      required: true,
      value: Object,
    }
  },

  data() {
    return {
      dataType: "agent", //Accepted types are "campaign", "agent", or "queue"
    };
  },

  mounted() {
    this.registerDependencies();
  },

  computed: {
    conf() {
      return this.config; // Allows the parent to change the config reactively
    },

    layoutLocked(){
      return this.$store.getters.locked
    }
  },

  methods: {
    registerDependencies(){
      //e.g 
      //this.$store.getters.agentArgs.addAgentState(6);
      //this.$store.getters.agentArgs.addAgentState(7);
    }

    // * If any methods alter the config, use
    // * this.$emit("changeConfig", this.conf)
    // * To notify the parent of the confid change
  },
};
</script>

<style scoped>
</style>